<template>
  <v-dialog v-model="dialog" max-width="440">
    <v-card>
      <v-card-title class="headline"> Результат </v-card-title>

      <v-card-text>
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="white darken-1" text @click="dialog = false">
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Dialog",
  props: ["message", "show"],
  data() {
    return {
      dialog: this.show
    };
  }
};
</script>

<style scoped></style>
